import React from 'react';
import CloseIcon from '@mui/icons-material/Close';
import NavigateBeforeIcon from '@mui/icons-material/NavigateBefore';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import Box from '@mui/material/Box';
import Dialog from '@mui/material/Dialog';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';

function PhotoViewer({ photos, initialIndex = 0, open, onClose }) {
  const [index, setIndex] = React.useState(initialIndex);

  React.useEffect(() => {
    if (open) setIndex(initialIndex);
  }, [initialIndex, open]);

  React.useEffect(() => {
    if (!open) return undefined;
    const handleKeyDown = event => {
      if (event.key === 'ArrowLeft') setIndex(current => Math.max(0, current - 1));
      if (event.key === 'ArrowRight') setIndex(current => Math.min(photos.length - 1, current + 1));
      if (event.key === 'Escape') onClose();
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [onClose, open, photos.length]);

  const photo = photos[index];
  if (!photo) return null;

  return (
    <Dialog open={open} onClose={onClose} maxWidth="lg" fullWidth PaperProps={{ sx: { backgroundColor: '#151515' } }}>
      <Box sx={{ position: 'relative', minHeight: { xs: '60vh', sm: '75vh' }, display: 'flex', alignItems: 'center', justifyContent: 'center', p: 2 }}>
        <IconButton onClick={onClose} aria-label="Close photo viewer" sx={{ position: 'absolute', top: 8, right: 8, color: '#fff', zIndex: 1 }}>
          <CloseIcon />
        </IconButton>
        <Box component="img" src={photo.fullDownloadUrl || photo.downloadUrl} alt={photo.originalFileName || ''} sx={{ maxWidth: '100%', maxHeight: '72vh', objectFit: 'contain' }} />
        {index > 0 && <IconButton onClick={() => setIndex(current => current - 1)} aria-label="Previous photo" sx={{ position: 'absolute', left: 8, color: '#fff' }}><NavigateBeforeIcon fontSize="large" /></IconButton>}
        {index < photos.length - 1 && <IconButton onClick={() => setIndex(current => current + 1)} aria-label="Next photo" sx={{ position: 'absolute', right: 8, color: '#fff' }}><NavigateNextIcon fontSize="large" /></IconButton>}
        <Typography variant="caption" sx={{ position: 'absolute', bottom: 8, color: '#fff' }}>{index + 1} / {photos.length}</Typography>
      </Box>
    </Dialog>
  );
}

export default PhotoViewer;
